import styles from './box.module.scss';
import MaterialBox from '@mui/material/Box';

/* eslint-disable-next-line */
export interface BoxProps {
  children?: any,
  component?: any,
  sx?: any,
  className?: any,
  onClick?: (event: any) => void,
  ['data-testid']?: string,
}

export function Box(props: BoxProps) {
  const localSx = {
    backgroundColor: '#fff',
  };

  return (
    <MaterialBox
      component={props.component}
      className={props.className}
      sx={Object.assign(localSx, props.sx)}
      onClick={props.onClick}
      data-testid={props['data-testid']}>
      {props.children}
    </MaterialBox>
  );
}

export default Box;